import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
export const movementSlice = createSlice({
  name: 'movement',
  initialState: {
    refreshMovement:{isRefresh : false},
    plannedOnAgenda:{status : false},
  },
  reducers: {    
    refreshMovement: (state, action) => {
      state.refreshMovement.isRefresh = action.payload;      
      return state;
    },    
    // to clear selection in grid after successfull drop on agenda
    setPlannedOnAgendaMovement:(state, action) => {
      state.plannedOnAgenda.status = action.payload      
      return state;
    },    
  }
})
// case under reducers becomes an action 
export const {refreshMovement,setPlannedOnAgendaMovement } = movementSlice.actions
export default movementSlice.reducer 
